import { Error } from '../error';
import { UrlsInput } from '../input';
import { Collapsible } from '../collapsible';
import { AIInput } from './input/AIInput';
import { ProxyInput } from './input/ProxyInput';
import { VisiterInput } from './input/VisiterInput';
import { TemplateInput } from './input/TemplateInput';
import { ExtractOptionsInput } from './input/ExtractOptionsInput';
import { Inner } from './Inner';
import { Required } from './Required';
import { Optional } from './Optional';
import { paramsInputsStyle } from './shared';

export const RunExtract = (props) => {
  const renderChildren = (params, onChange, setParams, errors) => {
    return (
      <div style={paramsInputsStyle}>
        <Required style={paramsInputsStyle} slim={props.hideAdvanced}>
          <UrlsInput
            label="URLs"
            help="URLs to extract data from (one per line)"
            errors={errors}
            value={params.urls}
            onChange={(val) => onChange('urls', val)}
          />
          <TemplateInput params={params} onChange={onChange} />
        </Required>
        <Optional style={paramsInputsStyle} hide={props.hideAdvanced}>
          <div style={{ display: 'flex', gap: 10 }}>
            <VisiterInput params={params} onChange={onChange} errors={errors} />
            <ProxyInput params={params} onChange={onChange} errors={errors} />
            <AIInput params={params} onChange={onChange} errors={errors} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <ExtractOptionsInput params={params} onChange={onChange} errors={errors} />
          </div>
        </Optional>
      </div>
    );
  };

  const examples = [
    {
      name: 'pokemondb.net',
      params: {
        urls: [
          'https://pokemondb.net/pokedex/bulbasaur',
          'https://pokemondb.net/pokedex/ivysaur',
          'https://pokemondb.net/pokedex/venusaur',
        ],
        template: 'pokemon name, number and basic stats.',
        // template: { name: 'pokemon name', number: 'pokemon number' },
      },
    },
  ];

  return (
    <Inner
      endpoint="extract"
      required={['urls', 'template']}
      initialParams={props.params}
      examples={examples}
      renderChildren={renderChildren}
      {...props}
    />
  );
};
